var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-text",on:{"click":_vm.redirect}},[_c('span',[_vm._v(_vm._s([
                _vm.resource.title !== 'other' ? _vm.uLang(`app.${_vm.resource.title}`) : '',
                _vm.resource.first_name,
                _vm.resource.prefix,
                _vm.resource.last_name
            ].join(' ')))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.resource.organisation ? _vm.resource.organisation.name : '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }